import {http} from '@/http/index.js';

async function likeComment(commentId) {
  return http.post(`/comments/${commentId}/like`);
}

export {likeComment};
